import React, { Component } from 'react';
import {
  Typography, TextField, Button, CircularProgress
} from '@material-ui/core';
import PropTypes from 'prop-types';

// Components
import InfoButton from './InfoButton';

// Redux
import { connect } from 'react-redux';
import { setSuccess, clearErrors, setAlert } from '../redux/actions/alertActions';

// Constants
import { DEFAULT, HelpDescriptions } from '../constants';

// Server Code
import { createBuilding, updateBuilding } from '../api';
import { T } from '../constants/tokens';

class CreateBuilding extends Component {

  constructor(props) {
    super(props);

    this.state = {
      buildingName: '',
      buildingCode: '',
      formError: false,
      isLoading: false
    };
  }

  componentDidMount() {
    // If building is passed in we should populate our state with its values.
    if (this.props.building != null) {
      const building = this.props.building;
      this.setState({
        buildingName: building.getName() || '',
        buildingCode: building.getCode() || ''
      });
    }
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  hasFormError() {
    return this.state.buildingName === '' || this.state.buildingCode === '';
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  submitForm = (e) => {
    e.preventDefault();

    // Ensure there is no form error
    const formError = this.hasFormError();
    this.setState({ formError });
    if (formError) return;

    const { buildingName, buildingCode } = this.state;

    // Update Existing Building
    if (this.props.building != null) {
      this.setState({ isLoading: true });
      updateBuilding({ id: this.props.building.getID(), name: buildingName }).then(() => {
        this.props.setSuccess('Successfully updated Building');
        this.setState({ isLoading: false, buildingName: '', buildingCode: '' });
        this.props.onSuccess();
      }).catch(error => {
        this.props.setError(error ? error : 'Error: Unable to updated building.');
        this.setState({ isLoading: false });
      });
    }

    // Create New Building
    else {
      this.setState({ isLoading: true });
      createBuilding({ name: buildingName, code: buildingCode }).then(() => {
        this.props.setSuccess('Successfully created Building');
        this.setState({ isLoading: false, buildingName: '', buildingCode: '' });
        this.props.onSuccess();
      }).catch(error => {
        this.props.setError(error ? error : 'Error: Unable to create building.');
        this.setState({ isLoading: false });
      });
    }
  }

  render() {
    return (
      <form onSubmit={this.submitForm} autoComplete='off' style={{ background: T.surfaceCard, border: '1px solid ' + T.hairline, borderRadius: 6, padding: 20, maxWidth: 680, width: '100%' }}>
        {/* Building Name Input */}
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16, padding: '12px 0', borderBottom: '1px solid ' + T.hairlineSoft }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, flex: '1 1 200px', minWidth: 0 }}>
            <Typography variant='h6' style={{ flex: 1, minWidth: 0 }}>Building Name</Typography>
            <InfoButton name={HelpDescriptions.TEMP.name} body={HelpDescriptions.TEMP.body} />
          </div>
          <TextField required error={this.state.formError && this.state.buildingName === ''} name="buildingName" label="Building Name (ex: Main Building)" style={{ flex: '1 1 280px', minWidth: 0 }} value={this.state.buildingName} onChange={this.onChange} variant='outlined' />
        </div>

        {/* Building Code Input */}
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16, padding: '12px 0', borderBottom: '1px solid ' + T.hairlineSoft }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, flex: '1 1 200px', minWidth: 0 }}>
            <Typography variant='h6' style={{ flex: 1, minWidth: 0 }}>Building Code</Typography>
            <InfoButton name={HelpDescriptions.TEMP.name} body={HelpDescriptions.TEMP.body} />
          </div>
          <TextField disabled={this.props.building != null} required error={this.state.formError && this.state.buildingCode === ''} name="buildingCode" label="Building Code (ex: MAIN)" style={{ flex: '1 1 280px', minWidth: 0 }} value={this.state.buildingCode} onChange={this.onChange} variant='outlined' />
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end', gap: 12, marginTop: 20 }}>
          <Button type='submit' variant="contained" color='primary' disabled={this.state.isLoading}>
            Save
            {this.state.isLoading && <CircularProgress size={16} style={{ color: 'inherit', marginLeft: 8 }} />}
          </Button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isMobile: state.ui.isMobile,
  isFullWidth: state.ui.isFullWidth
});

const mapDispatchToProps = (dispatch) => ({
  setError: (msg) => {
    dispatch(clearErrors());
    setAlert(dispatch, msg);
  },
  setSuccess: (msg) => setSuccess(dispatch, msg),
  clearErrors: () => dispatch(clearErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateBuilding);

CreateBuilding.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  setSuccess: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  statusColor: PropTypes.object,
  building: PropTypes.object,
  onSuccess: PropTypes.func.isRequired
};
